<app-solid-label width="140" [background]="backgroundColor" [content]="status | toSpanish : 'MALE' | capitalizeFirstLetters "></app-solid-label>